// extracted by mini-css-extract-plugin
module.exports = {"references-card":"styles-module__references-card___1ZVMw","card-content-max-width":"styles-module__card-content-max-width___R_lM2"};